import { Link } from "react-router-dom";
import logo from '../../static/images/logo.png';

export default function NotFound() {
  return (
    <div
      style={{
        background: "#0f1419",
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
        }}
      >
        <div className="logo" style={{ marginBottom: "32px" }}>
          <img
            src={logo}
            alt="Logo"
            className="logo-img"
            loading="eager"
            style={{ width: "300px", height: "auto" }}
          />
        </div>

        <div style={{ textAlign: "center" }}>
          <h1 style={{ color: "white" }}>
            404 - Página não encontrada
          </h1>
          <p style={{ color: "white" }}>
            A página que você está procurando não existe.
          </p>

          <Link
            to="/"
            className="btn-primary"
            style={{
              width: "250px",
              margin: "3em auto",
              justifyContent: "center",
              display: "block",
            }}
          >
            Voltar para o início
          </Link>
        </div>
      </div>
    </div>
  );
}
